import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import {
  Button,
  // Image,
  Menu
} from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
// import closeWin from '../img/glyph-x.svg';

import '../css/TopNav.less';

export default
@inject(
  'appManager', 'courseManager')
@observer
class PublisherAdminTopNav extends Component {
  constructor(props) {
    super(props);

    this.Avatar = SatCoreComponent('Avatar');
    this.LogoButtons = SatCoreComponent('LogoButtons');
  }

  componentDidMount = () => {
    const { appManager, history } = this.props;
    this.unlisten = history?.listen?.((location, _action) => {
      appManager.setLocation(location);
    });
  }

  componentWillUnmount = () => {
    this.unlisten?.();
  }

  closeWindow = async () => {
    window.close();
  }

  render() {
    const { courseManager, history, location } = this.props;
    const { LogoButtons } = this;

    return (
      <Menu className='topNav' fixed='top' inverted>
        <LogoButtons history={history} location={location} navButton={false} />
        <Menu.Item>
          Previewing :
          {' '}
          {courseManager.currentCourseName}
        </Menu.Item>
        <Menu.Menu position='right'>
          <Menu.Item as='a' className='tnav-tab close-nav' onClick={this.closeWindow} tabIndex='0'>
            {/* <Image alt='' src={closeWin} /> */}
            <Button
              aria-label='Close window'
              basic
              className='btn-top-nav-close'
              icon='close'
              onClick={this.closeWindow}
              size='huge' />
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    );
  }
}

SatCoreRegister('PublisherAdminTopNav', withRouter(PublisherAdminTopNav));
